import styles from "./LoginPage.module.css";
import ArrowRight from "../../assets/images/ArrowRight1.svg";
import BlackbaudLogoRec from "../../assets/images/BlackbaudLogoRec.png";
// import HomePageImage from "../../assets/images/HomePageImage.png";
import HomePageImage from "../../assets/images/HomePageImage1.jpeg";
// import LoginPageLogo from "../../assets/images/LoginPageLogo.png";
import LoginPageLogo from "../../assets/images/Visualise_Wordmark.png";
import { useContext, useState } from "react";
import { AuthContext } from "react-oauth2-code-pkce";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
} from "@mui/material";
import { CustomTextField } from "../../helpers/helper";
import { validateEmail } from "../../helpers/helper";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import {
  AUTH_URI,
  BASE_URL,
  CLIENT_ADMIN_ROLE_ID,
  CLIENT_ID,
  REDIRECT_URI,
  TOKEN_URI,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../../constants/constant";
import { useDispatch, useSelector } from "react-redux";
import { updateBBUser, updateCurrentUser } from "../../reduxSlices/userSlice";
import Loader from "../../components/loader/Loader";

const service = new Service();

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const [userEmail, setUserEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  //const searchParams = localStorage.getItem("searchParams");
  // const handleLogin = () => {
  //   localStorage.setItem("searchParams", "/");
  //   console.log("login called from<<<<<<<<<<<<<<<<<<<<<loginpage - 17");
  //   login();
  // };

  const checkUserLogin = () => {
    localStorage.setItem("searchParams", "/");
    console.log("login called from<<<<<<<<<<<<<<<<<<<<<loginpage - 17");
    if (validEmail) {
      setIsButtonClicked(false);
      //login();
      getUserLogin();
    } else {
      setIsButtonClicked(true);
    }
    //login();
  };

  const client_id = CLIENT_ID;
  const redirectUri = REDIRECT_URI;

  const getUserLogin = async () => {
    setLoading(true);
    setIsButtonClicked(false);
    let url = `/api/User/CheckUserLogin?email=` + userEmail + `&isFirstLogin=true`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let res = await service.newPostApi(url, {}, user_token);
      let response = res.data;
      if (response.success == false) {
        if (response.errorMessage == "User environment does not exist")
          login();
        toast.error(response.errorMessage, toastConfig);
        setLoading(false);
      }
      else {
        //get user tokens and then call login api
        let bbUserData = response.data;
        if (bbUserData && bbUserData?.token == null && bbUserData?.environmentId != null) {
          //get code and then call the api again
          localStorage.setItem("email", bbUserData?.emailId);
          localStorage.setItem("environment_id", bbUserData?.environmentId);
          localStorage.setItem("isFirstLogin", true);
          const url = `https://app.blackbaud.com/oauth/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirectUri}&environment_id=${bbUserData?.environmentId}`;
          window.open(url, `_self`);
        }
        localStorage.setItem("email", bbUserData?.emailId);
        localStorage.setItem("bb_access_token", bbUserData?.token);
        fetchUserLoginData(bbUserData);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, toastConfig);
      setLoading(false);
    }
  };

  const handleUserChange = (e) => {
    const email = e.target.value;
    const isValidEmail = validateEmail(email);
    if (isValidEmail) {
      setValidEmail(isValidEmail);
    }
    setUserEmail(email);
  };

  const fetchUserLoginData = async (bbUserData) => {
    setLoading(true);
    const searchParams = localStorage.getItem("searchParams")
    const url = `${BASE_URL}/api/User/UserLogin`;
    const params = { email: localStorage.getItem("email") };
    const user_token = localStorage.getItem("bb_access_token");
    try {
      await service.testGetLoginApi(url, params, user_token).then(
        (response) => {
          const userData = response?.data;
          if (userData?.data && userData?.success) {
            console.log("userData<<<<<", userData);
            const userRole = userData?.data?.roles?.map((item) => item.roleId);
            const envIsActive = userData?.data?.environments?.map(
              (item) => item?.isActive
            );
            const userIsActive = userData?.data?.isActive;
            const isActive = envIsActive && userIsActive;
            console.log("isActive<<<<<", isActive);
            const environmentId = userData?.data?.environments?.map(
              (item) => item?.environmentId
            );
            const organisationId = userData?.data?.organization?.organizationId;
            console.log("user_data", userRole, environmentId, organisationId);
            localStorage.setItem("user_data", JSON.stringify(userData.data));
            dispatch(updateCurrentUser(userData));
            if (
              userRole?.includes(VF_ADMIN_ROLE_ID) &&
              // userIsActive &&
              searchParams === "/admin"
            ) {
              navigate("/dashboard");
              localStorage.setItem("showDisclaimer", true);
              localStorage.setItem("showAlert", true);
            } else if (
              (userRole?.includes(USER_ROLE_ID) ||
                userRole?.includes(CLIENT_ADMIN_ROLE_ID)) &&
              environmentId?.includes(bbUserData?.environmentId) &&
              organisationId === bbUserData?.legalEntityId &&
              // isActive &&
              searchParams === "/"
            ) {
              navigate(userData?.data?.isNew ? "/user-review" : "/dashboard");
              localStorage.setItem("showDisclaimer", true);
              localStorage.setItem("showAlert", true);
            } else if (
              (userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
                userRole?.includes(VF_ADMIN_ROLE_ID)) &&
              environmentId?.includes(bbUserData?.environmentId) &&
              organisationId === bbUserData?.legalEntityId &&
              // isActive &&
              searchParams === "/admin"
            ) {
              navigate(
                userData?.data?.isNew && userRole?.includes(CLIENT_ADMIN_ROLE_ID)
                  ? "/setup-organisation"
                  : "/dashboard"
              );
              localStorage.setItem("showDisclaimer", true);
              localStorage.setItem("showAlert", true);
            } else {
              navigate("/accessdenied");
            }
          } else {
            localStorage.removeItem("user_data");
            navigate("/accessdenied");
            toast.warning(userData?.errorMessage, toastConfig);
          }
          setLoading(false)
        }
      )
        .catch(
          (error) => {
            console.error("Error fetching data:", error);
            setLoading(true);
          }
        );
    } catch (error) {
    }
  };
  if (loading) return <Loader />;
  return (
    <>
      <div className={styles.loginStaticImage1}>
        <div className={styles.imgDiv}>
          <img
            className={styles.loginStaticImageChild}
            alt=""
            src={HomePageImage}
          />
          <div className={styles.loginStaticImageItem} />
        </div>
        <div className={styles.contentDiv}>
          {/* <div className={styles.visualiseFundraising}>VISUALISE</div> */}
          <Link to="/home">
            <img className={styles.loginPageLogo} alt="" src={LoginPageLogo} />
          </Link>
          <div className={styles.loginYourAccount1}>Login to your account</div>
          <div className={styles.welcomeBackPlease1}>
            Welcome Back! Please login to your Visualise account to access your
            reports.
          </div>
          <div style={{ display: "flex" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <CustomTextField
                placeholder="Type your email here"
                sx={{
                  width: "335px",
                  marginRight: "10px"
                }}
                id="outlined-basic"
                variant="outlined"
                type="text"
                name="emailId"
                value={userEmail}
                onChange={handleUserChange}
              />
              {userEmail && !validEmail && isButtonClicked && (
                <Typography
                  sx={{
                    color: "red",
                    fontSize: "14px",
                    fontWeight: 500,
                    fontFamily: "Montserrat",
                  }}
                >
                  Email is not valid.
                </Typography>
              )}
            </Box>
            <div className={styles.rectangleParent}>
              <div className={styles.groupChild} onClick={checkUserLogin}>
                {/* <img className={styles.groupItem} alt="" src={BlackbaudLogoRec} /> */}
                <div className={styles.blackbaudReNxt}>Login</div>
                <img className={styles.arrowRight1} alt="" src={ArrowRight} />
              </div>
            </div>
          </div>
          <div className={styles.havingAnyQueryContainer}>
            <span className={styles.havingAnyQueryWriteUsAt}>
              <span>Need help? Write to us at</span>
              <span className={styles.span}>{` `}</span>
            </span>
            <b className={styles.infovisualisefundraisingcom}>
              info@visualisefundraising.com
            </b>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;

const labelStyle = {
  fontSize: "14px",
  letterSpacing: "-0.02em",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#282828",
  textAlign: "left",
  marginBottom: "8px",
};

const requiredAr = {
  color: "#CF4500",
  fontSize: "13px",
  verticalAlign: "baseline",
};